import { ColorModeScript } from "@chakra-ui/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

import "./font/BuenosAires-Black.eot";
import "./font/BuenosAires-Black.ttf";
import "./font/BuenosAires-Black.woff";
import "./font/BuenosAires-Black.woff2";
import "./font/BuenosAires-BlackItalic.eot";
import "./font/BuenosAires-BlackItalic.ttf";
import "./font/BuenosAires-BlackItalic.woff";
import "./font/BuenosAires-BlackItalic.woff2";
import "./font/BuenosAires-Bold.eot";
import "./font/BuenosAires-Bold.ttf";
import "./font/BuenosAires-Bold.woff";
import "./font/BuenosAires-Bold.woff2";
import "./font/BuenosAires-BoldItalic.eot";
import "./font/BuenosAires-BoldItalic.ttf";
import "./font/BuenosAires-BoldItalic.woff";
import "./font/BuenosAires-BoldItalic.woff2";
import "./font/BuenosAires-Book.eot";
import "./font/BuenosAires-Book.ttf";
import "./font/BuenosAires-Book.woff";
import "./font/BuenosAires-Book.woff2";
import "./font/BuenosAires-BookItalic.eot";
import "./font/BuenosAires-BookItalic.ttf";
import "./font/BuenosAires-BookItalic.woff";
import "./font/BuenosAires-BookItalic.woff2";
import "./font/BuenosAires-Light.eot";
import "./font/BuenosAires-Light.ttf";
import "./font/BuenosAires-Light.woff";
import "./font/BuenosAires-Light.woff2";
import "./font/BuenosAires-LightItalic.eot";
import "./font/BuenosAires-LightItalic.ttf";
import "./font/BuenosAires-LightItalic.woff";
import "./font/BuenosAires-LightItalic.woff2";
import "./font/BuenosAires-Regular.eot";
import "./font/BuenosAires-Regular.ttf";
import "./font/BuenosAires-Regular.woff";
import "./font/BuenosAires-Regular.woff2";
import "./font/BuenosAires-RegularItalic.eot";
import "./font/BuenosAires-RegularItalic.ttf";
import "./font/BuenosAires-RegularItalic.woff";
import "./font/BuenosAires-RegularItalic.woff2";
import "./font/BuenosAires-SemiBold.eot";
import "./font/BuenosAires-SemiBold.ttf";
import "./font/BuenosAires-SemiBold.woff";
import "./font/BuenosAires-SemiBold.woff2";
import "./font/BuenosAires-SemiBoldItalic.eot";
import "./font/BuenosAires-SemiBoldItalic.ttf";
import "./font/BuenosAires-SemiBoldItalic.woff";
import "./font/BuenosAires-SemiBoldItalic.woff2";
import "./font/BuenosAires-Thin.eot";
import "./font/BuenosAires-Thin.ttf";
import "./font/BuenosAires-Thin.woff";
import "./font/BuenosAires-Thin.woff2";
import "./font/BuenosAires-ThinItalic.eot";
import "./font/BuenosAires-ThinItalic.ttf";
import "./font/BuenosAires-ThinItalic.woff";
import "./font/BuenosAires-ThinItalic.woff2";

if (import.meta.env.MODE === "production") {
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ColorModeScript initialColorMode={"light"} />
    <App />
  </StrictMode>,
);
